import { List } from 'immutable';

import { basicCalculationEffects } from '../application/common/basicCalculation/effects';
import { conditionalEffects } from '../application/common/createConditional/effects';
import { reportEffects } from '../application/common/report/effects';
import { reportConfigurationEffects } from '../application/common/reportConfiguration/effects';
import { reportQueryEffects } from '../application/common/reportConfiguration/effects/reportQueryEffects';
import { reportTemplateEffects } from '../application/common/reportTemplate';
import { savedViewEffects } from '../application/common/savedViews/effects';
import { detailsTableExportEffects } from '../application/common/TableControls/exportEffects';
import { dimensionalTableEffects } from '../application/dimensionalTable/effects/dimensionalTableEffects';
import { lensEffects } from '../application/lenses/lensEffects';
import { reportExplorerRouteEffects } from '../application/reportExplorer/effects';
import { reportDimensionalEffects } from '../application/reportExplorer/effects/reportDimensionalEffects';
import { reportPdfEffects } from '../application/reportExplorer/ExportReportPdfModal/exportReportPdfEffects';
import { reportAccessEffects } from '../application/reportExplorer/ReportAccess/effects';
import { summaryTableEffects } from '../application/summaryTable/effects';

export const effects = List([
  reportAccessEffects,
  reportDimensionalEffects,
  reportEffects,
  detailsTableExportEffects,
  reportConfigurationEffects,
  reportExplorerRouteEffects,
  reportQueryEffects,
  reportTemplateEffects,
  basicCalculationEffects,
  conditionalEffects,
  savedViewEffects,
  summaryTableEffects,
  dimensionalTableEffects,
  reportPdfEffects,
  lensEffects
]);

export {
  reportAccessEffects,
  reportDimensionalEffects,
  reportEffects,
  reportConfigurationEffects,
  reportExplorerRouteEffects,
  reportQueryEffects,
  savedViewEffects,
  basicCalculationEffects,
  conditionalEffects,
  summaryTableEffects,
  reportTemplateEffects,
  dimensionalTableEffects,
  reportPdfEffects,
  lensEffects
};
